import store from "~/store/index"
import {formatDictData} from "~/utils/index"
/**
 * @description: 通过code获取label
 * @param {*}
 * @return {*}
 * @author: syx
 */
export const GetLabelByCode = (
  val,
  type,
  defaultVal
) => {
  return new Promise((resolve, reject) => {
    const { format } = store.state.dictConfig
    const dictList = store.state.dictCodes
    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (
        store.state.isGettingDictTypes.includes(type) ||
        store.state.isGettingAllDictTypes
      ) {
        //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (
            !(
              store.state.isGettingDictTypes.includes(type) ||
              store.state.isGettingAllDictTypes
            )
          ) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetItem = list.find((item) => {
              return item[format.value] === val
            })
            resolve(targetItem ? targetItem[format.label] : (defaultVal??""))
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetItem = list.find((item) => {
            return item[format.value] === val
          })
          resolve(targetItem ? targetItem[format.label] : (defaultVal??""))
        })
      }
    } else {
      list = dictList[type]
      const targetItem = list.find((item) => {
        return item[format.value] === val
      })
      resolve(targetItem ? targetItem[format.label] : (defaultVal??""))
    }
  })
}

/**
 * @description: 通过codes获取labels
 * @param {*}
 * @return {*}
 * @author: syx
 */
export function GetLabelByCodesDothings(
  values,
  list,
  format,
  defaultVal
) {
  const targetArr = []
  for (let i = 0; i < values.length; i++) {
    const findItem = list.find((item) => {
      return item[format.value] === values[i]
    })
    if (findItem) {
      targetArr.push(findItem)
    } else {
      targetArr.push({
        [format.label]: defaultVal,
        [format.value]: values[i]
      })
    }
  }
  return targetArr
}

export const GetLabelByCodes = (
  vals,
  type,
  options
) => {
  const defaultOptions = {
    defaultVal: "",
    formatFun: (arr,
      format) => {
      return arr
        .map((item) => {
          return item[format.label]
        })
        .join(",")
    },
    spacer: ","
  }
  Object.assign(defaultOptions, options) 
  return new Promise((resolve, reject) => {
    let values = []
    if (Array.isArray(vals)) {
      values = vals
    } else if (typeof vals === "string") {
      values = vals.split(defaultOptions.spacer)
    }

    const { format } = store.state.dictConfig
    const dictList = store.state.dictCodes

    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (
        store.state.isGettingDictTypes.includes(type) ||
        store.state.isGettingAllDictTypes
      ) {
        //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (
            !(
              store.state.isGettingDictTypes.includes(type) ||
              store.state.isGettingAllDictTypes
            )
          ) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetArr = GetLabelByCodesDothings(
              values,
              list,
              format,
              defaultOptions.defaultVal
            )
            resolve(
              targetArr && targetArr.length > 0
                ? defaultOptions.formatFun(targetArr, format)
                : defaultOptions.defaultVal
            )
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetArr = GetLabelByCodesDothings(
            values,
            list,
            format,
            defaultOptions.defaultVal
          )
          resolve(
            targetArr && targetArr.length > 0
              ? defaultOptions.formatFun(targetArr, format)
              : defaultOptions.defaultVal
          )
        })
      }
    } else {
      list = dictList[type]
      const targetArr = GetLabelByCodesDothings(
        values,
        list,
        format,
        defaultOptions.defaultVal
      )
      resolve(
        targetArr && targetArr.length > 0
          ? defaultOptions.formatFun(targetArr, format)
          : defaultOptions.defaultVal
      )
    }
  })
}

/**
 * @description: 通过label获取code
 * @param {*}
 * @return {*}
 * @author: syx
 */
export const GetCodeByLabel = (
  val,
  type,
  defaultVal
) => {
  return new Promise((resolve, reject) => {
    const { format } = store.state.dictConfig
    const dictList = store.state.dictCodes
    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (
        store.state.isGettingDictTypes.includes(type) ||
        store.state.isGettingAllDictTypes
      ) {
        //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (
            !(
              store.state.isGettingDictTypes.includes(type) ||
              store.state.isGettingAllDictTypes
            )
          ) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetItem = list.find((item) => {
              return item[format.label] === val
            })
            resolve(targetItem ? targetItem[format.value] : (defaultVal??""))
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetItem = list.find((item) => {
            return item[format.label] === val
          })
          resolve(targetItem ? targetItem[format.value] : (defaultVal??""))
        })
      }
    } else {
      list = dictList[type]
      const targetItem = list.find((item) => {
        return item[format.label] === val
      })
      resolve(targetItem ? targetItem[format.value] : (defaultVal??""))
    }
  })
}

/**
 * @description: 通过labels 获取code
 * @param {*}
 * @return {*}
 * @author: syx
 */
export function GetCodeByLabelsDothings(
  values,
  list,
  format,
  defaultVal
) {
  const targetArr = []
  for (let i = 0; i < values.length; i++) {
    const findItem = list.find((item) => {
      return item[format.label] === values[i]
    })
    if (findItem) {
      targetArr.push(findItem)
    } else {
      targetArr.push({
        [format.label]: values[i],
        [format.value]: defaultVal
      })
    }
  }
  return targetArr
}

export const GetCodeByLabels = (
  vals,
  type,
  options
) => {
  const defaultOptions = {
    defaultVal: "",
    formatFun: (arr,
      format) => {
      return arr
        .map((item) => {
          return item[format.value]
        })
        .join(",")
    },
    spacer: ","
  }
  Object.assign(defaultOptions, options) 
  return new Promise((resolve, reject) => {
    let values = []
    if (Array.isArray(vals)) {
      values = vals
    } else if (typeof vals === "string") {
      values = vals.split(defaultOptions.spacer)
    }

    const { format } = store.state.dictConfig
    const dictList = store.state.dictCodes

    let list = []
    //如果没找到此类型的数据
    if (!dictList || !dictList[type]) {
      if (
        store.state.isGettingDictTypes.includes(type) ||
        store.state.isGettingAllDictTypes
      ) {
        //如果有别的地方在请求这个字典类型数据  轮询查看是否请求结束
        const timer = setInterval(() => {
          if (
            !(
              store.state.isGettingDictTypes.includes(type) ||
              store.state.isGettingAllDictTypes
            )
          ) {
            clearInterval(timer)
            list = store.state.dictCodes[type]
            if (!list) {
              reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
              return
            }
            const targetArr = GetCodeByLabelsDothings(
              values,
              list,
              format,
              defaultOptions.defaultVal
            )
            resolve(
              targetArr && targetArr.length > 0
                ? defaultOptions.formatFun(targetArr, format)
                : defaultOptions.defaultVal
            )
          }
        }, 1000)
      } else {
        store.actions.getDictDataObj(type).then((data) => {
          list = data[type]
          if (!list) {
            reject(`不存在类型为：${type} 的字典字段，请确认后再填写`)
            return
          }
          const targetArr = GetCodeByLabelsDothings(
            values,
            list,
            format,
            defaultOptions.defaultVal
          )
          resolve(
            targetArr && targetArr.length > 0
              ? defaultOptions.formatFun(targetArr, format)
              : defaultOptions.defaultVal
          )
        })
      }
    } else {
      list = dictList[type]
      const targetArr = GetCodeByLabelsDothings(
        values,
        list,
        format,
        defaultOptions.defaultVal
      )
      resolve(
        targetArr && targetArr.length > 0
          ? defaultOptions.formatFun(targetArr, format)
          : defaultOptions.defaultVal
      )
    }
  })
}

/**
 * @description: 通过dictType返回该字典类型数据
 * @param {*}
 * @return {*}
 * @author: syx
 */
export const GetDictObjByDictTypes = (dictTypes) => {
  return new Promise((resolve, reject) => {
    let values = []
    let typeStr = ""
    if (Array.isArray(dictTypes)) {
      typeStr = dictTypes.join(",")
      values = dictTypes
    } else if (typeof dictTypes === "string") {
      values = dictTypes.split(",")
    }

    const dictList = store.state.dictCodes
    const setting = store.state.dictConfig
    //不存在字典值
    if (!dictList) {
      //添加正在请求的字典数据
      store.mutations.ADD_IS_EGTTING_DICT_TYPES(typeStr)
      setting
        .getDictCodeApi(setting.formatterRequest(setting.query, typeStr))
        .then((data) => {
          //去除正在请求的字典数据
          store.mutations.REMOVE_IS_EGTTING_DICT_TYPES(typeStr)
          // 获取到的字典数据
          const dictData = setting.formatterDictList(data, dictTypes)
          // 格式化字典数据
          const resultDictData = formatDictData(dictData, setting.filterDataFun, setting.disabledDataFun)

          const copyObj = JSON.parse(JSON.stringify(resultDictData))
          const allDictObj = Object.assign(store.state.dictCodes, copyObj)
          setting.storage.setItem(
            setting.dictDataKey,
            JSON.stringify(allDictObj)
          )
          store.mutations.SET_DICT_CODES(allDictObj)
          resolve(resultDictData)
        })
    } else {
      const needGetArr = [] //保留需要请求的字典数组类型
      const haveDictObj = {} //已经有的字典数据类型数据
      for (let i = 0; i < values.length; i++) {
        if (dictList[values[i]]) {
          haveDictObj[values[i]] = dictList[values[i]]
          continue
        }
        needGetArr.push(values[i])
      }

      if (needGetArr.length > 0) {
        //添加正在请求的字典数据
        store.mutations.ADD_IS_EGTTING_DICT_TYPES(needGetArr.join(","))
        setting
          .getDictCodeApi(
            setting.formatterRequest(setting.query, needGetArr.join(","))
          )
          .then((data) => {
            //去除正在请求的字典数据
            store.mutations.REMOVE_IS_EGTTING_DICT_TYPES(needGetArr.join(","))
            const dictData = setting.formatterDictList(data, dictTypes)
            // 格式化字典数据
            const resultDictData = formatDictData(dictData, setting.filterDataFun, setting.disabledDataFun)
            const copyObj = JSON.parse(JSON.stringify(resultDictData))
            const allDictObj = Object.assign(store.state.dictCodes, copyObj)
            setting.storage.setItem(
              setting.dictDataKey,
              JSON.stringify(allDictObj)
            )
            store.mutations.SET_DICT_CODES(allDictObj)

            const resolveDict = Object.assign(haveDictObj, dictData)

            const noDictTypeArr = []
            for (const key in resolveDict) {
              if (!resolveDict[key] || resolveDict[key].length === 0) {
                noDictTypeArr.push(key)
              }
            }
            if (noDictTypeArr.length > 0) {
              reject(
                `不存在类型为：${noDictTypeArr.join(
                  "、"
                )} 的字典字段，请确认后再填写`
              )
            }
            resolve(resultDictData)
          })
      } else {
        resolve(haveDictObj)
      }
    }
  })
}
